import { Row, Col, Card, Button, Input, Form, Badge, Tabs, Select, Space, Spin, Checkbox, Radio, Alert, Table, Empty } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { useLocation, useNavigate, useParams } from "react-router";
import apiPath from "../../constants/apiPath";
import FileUpload from "../../components/FileUpload";
import languages from "../../config/language";
import DescriptionEditor from '../../components/DescriptionEditor';
import CategorySelect from "../../components/select/CategorySelect";
import SegmentSelect from "../../components/select/SegmentSelect";
import VehicleManufacturerSelect from "../../components/select/VehicleManufacturerSelect";
import TextArea from "antd/es/input/TextArea";
import { CheckLineIcon, Trash2 } from "lucide-react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import BrandSelect from "../../components/select/BrandSelect";
const { TabPane } = Tabs;

function AddEdit() {

    const sectionName = "Product";
    const routeName = "product";
    const { id } = useParams();
    const isEdit = Boolean(id);

    const api = {
        addEdit: apiPath.addEditProduct,
        category: apiPath.commonCategory,
        edit: apiPath.editProduct,
    }

    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const activeTab = query.get("tab") || "all";
    const isWithoutVehicleTab = activeTab === "without-vehicle";
    const [form] = Form.useForm();
    const { request } = useRequest()
    const [loading, setLoading] = useState(false)
    const [fetching, setFetching] = useState(false);
    const navigate = useNavigate();
    const [image, setImage] = useState([]);
    const [validationStatus, setValidationStatus] = useState({});
    const [allVehicle, setAllVehicle] = useState(false);

    const [brandId, setBrandId] = useState(null);
    const [categoryId, setCategoryId] = useState(null);
    const [segmentId, setSegmentId] = useState(null);

    const [vehicleOption, setVehicleOption] = useState(null);
    const [selectedManufacturers, setSelectedManufacturers] = useState([]);
    const [selectedModels, setSelectedModels] = useState('all');
    const [manufacturers, setManufacturers] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [models, setModels] = useState([]);
    const [selectedManufacturer, setSelectedManufacturer] = useState(null);
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [selectedSpecificModels, setSelectedSpecificModels] = useState([]);
    const [vehicleModelMappings, setVehicleModelMappings] = useState([]);
    const [loadingVehicles, setLoadingVehicles] = useState(false);
    const [loadingModels, setLoadingModels] = useState(false);

    const handleFieldChange = (data, lang, type) => {
        const name = form.getFieldValue(`${lang}_name`);
        const description = form.getFieldValue(`${lang}_description`);
        const isDescriptionEmpty = !description || (description.trim() === '<p></p>' || description.trim() === "");
        setValidationStatus(prevStatus => ({
            ...prevStatus,
            [lang]: !!name && !isDescriptionEmpty
        }));
    }

    const fetchData = (id) => {
        setFetching(true);
        request({
            url: api.edit + "/" + id,
            method: 'GET',
            onSuccess: (response) => {
                const { data } = response;
                form.setFieldsValue({
                    ...data,
                    all_vehicle: data?.all_vehicle !== undefined ? data.all_vehicle : false
                });

                if (data?.image) {
                    setImage([{ url: data.image_url }]);
                }

                if (data?.brand_id) {
                    setBrandId(data.brand_id);
                }
                if (data?.category_id) {
                    setCategoryId(data.category_id);
                }
                if (data?.segment_id) {
                    setSegmentId(data.segment_id);
                }

                const isAllVehicle = data?.all_vehicle !== undefined ? data.all_vehicle : false;
                setAllVehicle(isAllVehicle);

                if (data?.vehicle_mapping_option) {
                    setVehicleOption(data.vehicle_mapping_option);

                    if (data.vehicle_mapping_option === 'specific' && data?.vehicle_model_mappings) {
                        setVehicleModelMappings(data.vehicle_model_mappings);
                    } else if (data.vehicle_mapping_option === 'manufacturers' && data?.vehicle_manufacturer_ids) {
                        setSelectedManufacturers(data.vehicle_manufacturer_ids);
                    }
                } else {
                    setVehicleOption(null);
                }

                setFetching(false);
            },
            onError: (error) => {
                setFetching(false);
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    useEffect(() => {
        const initialValidationStatus = {};

        languages.forEach(lang => {
            initialValidationStatus[lang.short] = !!form.getFieldValue(`${lang.short}_name`) && !!form.getFieldValue(`${lang.short}_description`);
        });

        setValidationStatus(initialValidationStatus);
    }, [])

    useEffect(() => {
        if (!selectedManufacturer) {
            setVehicles([]);
            setSelectedVehicle(null);
            setModels([]);
            setSelectedSpecificModels([]);
            return;
        }

        setLoadingVehicles(true);
        request({
            url: `${apiPath.commonVehicle}?manufacturer_id=${selectedManufacturer}&segment_id=${segmentId || ""}`,
            method: 'GET',
            onSuccess: (response) => {
                const vehicleList = response.data?.data || [];
                setVehicles(vehicleList);
                setLoadingVehicles(false);
            },
            onError: (error) => {
                setLoadingVehicles(false);
                ShowToast(error?.message || 'Failed to load vehicles', Severty.ERROR);
            }
        });
    }, [selectedManufacturer]);

    useEffect(() => {
        if (!selectedVehicle) {
            setModels([]);
            setSelectedSpecificModels([]);
            return;
        }

        setLoadingModels(true);
        request({
            url: `${apiPath.commonVehicleModel}?vehicle_id=${selectedVehicle}&segment_id=${segmentId || ""}`,
            method: 'GET',
            onSuccess: (response) => {
                const modelList = response.data?.data || [];
                setModels(modelList);
                setLoadingModels(false);
            },
            onError: (error) => {
                setLoadingModels(false);
                ShowToast(error?.message || 'Failed to load models', Severty.ERROR);
            }
        });
    }, [selectedVehicle]);

    useEffect(() => {
        if (vehicleOption === 'specific') {
            setLoadingModels(true);
            request({
                url: `${apiPath.commonManufacturer}?segment_id=${segmentId || ""}`,
                method: 'GET',
                onSuccess: (response) => {
                    const modelList = response.data?.data || [];
                    setManufacturers(modelList);
                    setLoadingModels(false);
                },
                onError: (error) => {
                    setLoadingModels(false);
                    ShowToast(error?.message || 'Failed to load models', Severty.ERROR);
                }
            });
        }
    }, [segmentId, vehicleOption]);

    const handleAddVehicleMapping = () => {
        if (!selectedManufacturer) {
            ShowToast('Please select a manufacturer', Severty.ERROR);
            return;
        }
        if (!selectedVehicle) {
            ShowToast('Please select a vehicle', Severty.ERROR);
            return;
        }

        const manufacturerName = manufacturers.find(m => m._id === selectedManufacturer)?.en_name;

        const mapping = {
            id: Date.now(),
            manufacturer_id: selectedManufacturer,
            manufacturer_name: manufacturerName,
            vehicle_id: selectedVehicle,
            model_selection: selectedModels,
            specific_models: selectedModels === 'specific' ? selectedSpecificModels : []
        };

        setVehicleModelMappings(prev => [...prev, mapping]);

        setSelectedVehicle(null);
        setSelectedModels('all');
        setSelectedSpecificModels([]);
        setModels([]);

        ShowToast('Vehicle & models added successfully', Severty.SUCCESS);
    };

    const handleRemoveVehicleMapping = (mappingId) => {
        setVehicleModelMappings(vehicleModelMappings.filter(m => m.id !== mappingId));
    };

    const handleFile = (data) => {
        setImage(data);
        form.setFieldValue('image', data);
    }

    const onCreate = (values) => {

        const formData = new FormData();

        formData.append("part_number", values.part_number || "");
        formData.append("price", values.price || "");
        formData.append("ref_no", values.ref_no || "");
        formData.append("brand_id", values.brand_id || "");
        formData.append("segment_id", values.segment_id || "");
        formData.append("category_id", values.category_id || "");
        formData.append("specification", values.specification || "");

        if (isWithoutVehicleTab || isEdit) {
            formData.append("all_vehicle", vehicleOption === 'all' ? true : false);
        } else {
            formData.append("all_vehicle", false);
        }

        if (isEdit && isWithoutVehicleTab === false) {
            languages.forEach((lang) => {
                formData.append(`${lang.short}_name`, values[`${lang.short}_name`] || "");
                formData.append(`${lang.short}_description`, values[`${lang.short}_description`] || "");
            });

            if (image && image[0]?.originFileObj) {
                formData.append("image", image[0].originFileObj);
            }
        }

        if (isEdit === false) {
            languages.forEach((lang) => {
                formData.append(`${lang.short}_name`, values[`${lang.short}_name`] || "");
                formData.append(`${lang.short}_description`, values[`${lang.short}_description`] || "");
            });

            if (image && image[0]?.originFileObj) {
                formData.append("image", image[0].originFileObj);
            }
        }

        setLoading(true)
        request({
            url: isEdit ? `${api.addEdit}/${id}` : api.addEdit,
            method: 'POST',
            data: formData,
            onSuccess: (data) => {
                setLoading(false)
                if (data.status) {
                    ShowToast(data.message, Severty.SUCCESS)
                    navigate(`/${routeName}${location.search}`);
                } else {
                    ShowToast(data.message, Severty.ERROR)
                }
            },
            onError: (error) => {
                ShowToast("Something went wrong, Please try again later", Severty.ERROR)
                setLoading(false)
            },
        })
    };

    useEffect(() => {
        if (isEdit) {
            fetchData(id);
        }
    }, [id]);

    const handleClose = () => {
        navigate(`/${routeName}${location.search}`);
    };

    const handleSaveVehicleMapping = () => {
        if (vehicleOption === 'manufacturers' && selectedManufacturers.length === 0) {
            ShowToast("Please select at least one manufacturer", Severty.ERROR);
            return;
        }

        if (vehicleOption === 'specific' && vehicleModelMappings.length === 0) {
            ShowToast("Please add at least one vehicle mapping", Severty.ERROR);
            return;
        }

        const formData = new FormData();

        formData.append("all_vehicle", vehicleOption === 'all' ? true : false);
        formData.append("vehicle_mapping_option", vehicleOption);

        if (vehicleOption === 'manufacturers') {
            formData.append("vehicle_manufacturer_ids", JSON.stringify(selectedManufacturers));
            formData.append("vehicle_model_mappings", JSON.stringify([]));
        } else if (vehicleOption === 'specific') {
            formData.append("vehicle_model_mappings", JSON.stringify(vehicleModelMappings));
            formData.append("vehicle_manufacturer_ids", JSON.stringify([]));
        } else {
            formData.append("vehicle_manufacturer_ids", JSON.stringify([]));
            formData.append("vehicle_model_mappings", JSON.stringify([]));
        }

        setLoading(true);
        request({
            url: `${api.addEdit}/${id}`,
            method: 'POST',
            data: formData,
            onSuccess: (data) => {
                setLoading(false);
                if (data.status) {
                    ShowToast(data.message, Severty.SUCCESS);
                    navigate(`/${routeName}${location.search}`);
                } else {
                    ShowToast(data.message, Severty.ERROR);
                }
            },
            onError: (error) => {
                ShowToast("Something went wrong, Please try again later", Severty.ERROR);
                setLoading(false);
            },
        });
    };

    return (
        <Card
            variant={false}
            className="criclebox tablespace mb-6 shadow-sm"
            title={`${isEdit ? "Edit" : "Add New"} ${sectionName}`}
            extra={
                <Button
                    type="primary"
                    onClick={handleClose}
                    icon={<ArrowLeftOutlined />}
                    className="flex items-center gap-1"
                >
                    Back
                </Button>
            }
        >
            <Spin spinning={fetching} tip="Loading product details...">


                {isEdit && isWithoutVehicleTab ? (
                    <>
                        <Card className="p-4 border-l-4 border-l-blue-500">

                            <h3 className="text-lg font-semibold text-gray-800 mb-4">Vehicle Mapping Options</h3>
                            <Alert
                                message="Select one of the options below to assign vehicles to this product according to current product segment"
                                type="info"
                                showIcon
                                className="mb-4"
                            />

                            <Form layout="vertical" className="vehicle-mapping-form p-4">
                                <Form.Item label="Select Vehicle Mapping Option" required>
                                    <Radio.Group value={vehicleOption} onChange={(e) => {
                                        setVehicleOption(e.target.value);
                                        setSelectedManufacturers([]);
                                        setSelectedModels('all');
                                        setSelectedManufacturer(null);
                                        setSelectedVehicle(null);
                                        setSelectedSpecificModels([]);
                                        setVehicleModelMappings([]);
                                    }}>
                                        <Space direction="vertical" className="w-full" size="large">

                                            <Row gutter={[24, 0]} className="space-y-4">

                                                <Col span={24} xs={24} sm={24} lg={24} xxl={24}>
                                                    <div className={`p-4 rounded-lg border shadow-sm cursor-pointer ${vehicleOption === "all" ? "border-blue-500 bg-blue-50" : "bg-white"}`}>
                                                        <Radio value="all">
                                                            <span className="font-medium">
                                                                Option 1: Available for All Vehicles
                                                            </span>

                                                            <p className="text-gray-600 text-sm mt-1 ml-6">
                                                                Product will be available for all vehicles and their models
                                                            </p>
                                                        </Radio>
                                                    </div>
                                                </Col>

                                                <Col span={24} xs={24} sm={24} lg={24} xxl={24}>
                                                    <div className={`p-4 rounded-lg border shadow-sm cursor-pointer ${vehicleOption === "manufacturers" ? "border-blue-500 bg-blue-50" : "bg-white"}`}>
                                                        <Radio value="manufacturers">
                                                            <span className="font-medium">
                                                                Option 2: All Vehicles of Selected Manufacturers
                                                            </span>

                                                            <p className="text-gray-600 text-sm mt-1 ml-6">
                                                                Select one or more manufacturers - product available for all their vehicles and models
                                                            </p>
                                                        </Radio>

                                                        {vehicleOption === 'manufacturers' && (
                                                            <div className="ml-6 mt-3 p-4 bg-white border rounded">

                                                                <h5 className="font-semibold mb-2">
                                                                    Select Vehicle Manufacturers <span className="text-red-500">*</span>
                                                                </h5>

                                                                <VehicleManufacturerSelect
                                                                    segmentId={segmentId}
                                                                    value={selectedManufacturers}
                                                                    onChange={setSelectedManufacturers}
                                                                    multiple={true}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </Col>

                                                <Col span={24} xs={24} sm={24} lg={24} xxl={24}>
                                                    <div className={`p-4 rounded-lg border shadow-sm cursor-pointer ${vehicleOption === "specific" ? "border-blue-500 bg-blue-50" : "bg-white"}`}>
                                                        <Radio value="specific">
                                                            <span className="font-medium">
                                                                Option 3: Specific Vehicles & Models
                                                            </span>

                                                            <p className="text-gray-600 text-sm mt-1 ml-6">
                                                                Select individual vehicles and optionally choose specific models
                                                            </p>
                                                        </Radio>

                                                        {vehicleOption === 'specific' && (
                                                            <div className="ml-6 mt-3 rounded space-y-4">

                                                                <div className="rounded p-4 bg-white border shadow-sm">

                                                                    <Row gutter={[16, 16]}>

                                                                        <Col span={24} xs={12} sm={12} md={12}>
                                                                            <h5 className="font-semibold mb-2">
                                                                                Select Manufacturer <span className="text-red-500">*</span>
                                                                            </h5>

                                                                            <VehicleManufacturerSelect
                                                                                segmentId={segmentId}
                                                                                value={selectedManufacturer}
                                                                                onChange={(value) => {
                                                                                    setSelectedManufacturer(value);
                                                                                    setSelectedVehicle(null);
                                                                                    setSelectedSpecificModels([]);
                                                                                }}
                                                                                multiple={false}
                                                                            />
                                                                        </Col>

                                                                        {selectedManufacturer && (
                                                                            <Col span={24} xs={12} sm={12} md={12}>

                                                                                <h5 className="font-semibold mb-2">
                                                                                    Select Vehicle <span className="text-red-500">*</span>
                                                                                </h5>

                                                                                <Select
                                                                                    placeholder="Select a vehicle..."
                                                                                    value={selectedVehicle}
                                                                                    onChange={(value) => {
                                                                                        setSelectedVehicle(value);
                                                                                        setSelectedSpecificModels([]);
                                                                                        setSelectedModels('all');
                                                                                    }}
                                                                                    loading={loadingVehicles}
                                                                                    style={{ width: '100%' }}
                                                                                    options={vehicles.map(v => ({
                                                                                        label: v.en_name,
                                                                                        value: v._id
                                                                                    }))}
                                                                                />
                                                                            </Col>
                                                                        )}

                                                                        {selectedVehicle && (
                                                                            <Col span={24} xs={24} sm={24} md={24}>

                                                                                <h5 className="font-semibold mb-3">Models for This Vehicle</h5>

                                                                                <Radio.Group
                                                                                    value={selectedModels}
                                                                                    onChange={(e) => {
                                                                                        setSelectedModels(e.target.value);
                                                                                        if (e.target.value === 'all') {
                                                                                            setSelectedSpecificModels([]);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <Space direction="vertical">
                                                                                        <Radio value="all"> All Models <span className="text-gray-500 text-xs">(Default)</span>
                                                                                        </Radio>
                                                                                        <Radio value="specific">Specific Models</Radio>
                                                                                    </Space>
                                                                                </Radio.Group>

                                                                                {selectedModels === 'specific' && (
                                                                                    <div className="mt-4 p-3 bg-gray-50 border rounded">
                                                                                        <Select
                                                                                            mode="multiple"
                                                                                            placeholder="Select specific models..."
                                                                                            value={selectedSpecificModels}
                                                                                            onChange={setSelectedSpecificModels}
                                                                                            loading={loadingModels}
                                                                                            style={{ width: '100%' }}
                                                                                            options={models.map(m => ({
                                                                                                label: m.en_name,
                                                                                                value: m._id
                                                                                            }))}
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                            </Col>
                                                                        )}

                                                                        <Col span={24}>
                                                                            <div className="flex justify-end">
                                                                                <Button
                                                                                    type="primary"
                                                                                    onClick={handleAddVehicleMapping}
                                                                                    disabled={!selectedManufacturer || !selectedVehicle}
                                                                                >
                                                                                    Add Vehicle
                                                                                </Button>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>

                                                                {vehicleModelMappings.length > 0 && (
                                                                    <div className="border p-4 bg-white rounded">
                                                                        <h4 className="font-semibold text-gray-700 mb-3">
                                                                            Added Vehicles & Models ({vehicleModelMappings.length})
                                                                        </h4>
                                                                        <Table
                                                                            dataSource={vehicleModelMappings}
                                                                            pagination={false}
                                                                            size="small"
                                                                            rowKey="id"
                                                                            columns={[
                                                                                {
                                                                                    title: 'Manufacturer',
                                                                                    dataIndex: 'manufacturer_name',
                                                                                    key: 'manufacturer_name',
                                                                                },
                                                                                {
                                                                                    title: 'Vehicle',
                                                                                    dataIndex: 'vehicle_id',
                                                                                    key: 'vehicle_id',
                                                                                    render: (vehicleId) => vehicleId?.toString() || '-',
                                                                                },
                                                                                {
                                                                                    title: 'Models',
                                                                                    dataIndex: 'model_selection',
                                                                                    key: 'model_selection',
                                                                                    render: (text, record) => (
                                                                                        <span>
                                                                                            {record.model_selection === 'all' ? 'All Models' : `${record.specific_models.length} Specific Models`}
                                                                                        </span>
                                                                                    )
                                                                                },
                                                                                {
                                                                                    title: 'Action',
                                                                                    key: 'action',
                                                                                    render: (_, record) => (
                                                                                        <Button
                                                                                            type="text"
                                                                                            danger
                                                                                            size="small"
                                                                                            onClick={() => handleRemoveVehicleMapping(record.id)}
                                                                                        >
                                                                                            <Trash2 size={14} /> Remove
                                                                                        </Button>
                                                                                    ),
                                                                                },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Space>
                                    </Radio.Group>
                                </Form.Item>

                                <Form.Item className="btn-row float-right mt-3">
                                    <Button type="primary" loading={loading} onClick={handleSaveVehicleMapping}>
                                        <CheckLineIcon size={15} /> Save Vehicle Mapping
                                    </Button>
                                </Form.Item>

                            </Form>
                        </Card>
                    </>

                ) : isEdit ? (

                    <Form className="edit-page-wrap" form={form} onFinish={onCreate} autoComplete="off" layout="verticle" name="blog_form">

                        <Row gutter={[24, 0]}>

                            <Col span={24} xs={24} sm={12} lg={12} xxl={8}>
                                <Form.Item
                                    label="Part Number"
                                    name="part_number"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter the part number!",
                                        },
                                    ]}
                                >
                                    <Input
                                        autoComplete="off"
                                        placeholder="Enter Part Number"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24} xs={24} sm={12} lg={12} xxl={8}>
                                <Form.Item
                                    label="Price (INR)"
                                    name="price"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter the price!",
                                        },
                                        {
                                            pattern: new RegExp(/^[\.0-9]*$/),
                                            message: "Only Numeric Characters Allowed",
                                        },
                                    ]}
                                >
                                    <Input
                                        maxLength={80}
                                        autoComplete="off"
                                        placeholder="Enter Price"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24} xs={24} sm={12} lg={12} xxl={8}>
                                <Form.Item
                                    label="Ref. No"
                                    name="ref_no"
                                    rules={[
                                    ]}
                                >
                                    <Input
                                        maxLength={80}
                                        autoComplete="off"
                                        placeholder="Enter Ref No"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24} xs={24} sm={12} lg={12} xxl={8}>
                                <Form.Item
                                    label="Brand"
                                    name="brand_id"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select the brand!",
                                        },
                                    ]}
                                >
                                    <BrandSelect
                                        value={brandId}
                                        onChange={(val) => {
                                            setBrandId(val);
                                            setCategoryId(null);
                                            setSegmentId(null);
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24} xs={24} sm={12} lg={12} xxl={8}>
                                <Form.Item
                                    label="Category"
                                    name="category_id"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select the category!",
                                        },
                                    ]}
                                >
                                    <CategorySelect
                                        brandId={brandId}
                                        disabled={!brandId}
                                        shouldFetch={!!brandId}
                                        value={categoryId}
                                        onChange={setCategoryId}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24} xs={24} sm={12} lg={12} xxl={8}>
                                <Form.Item
                                    label="Segment"
                                    name="segment_id"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select the segment!",
                                        },
                                    ]}
                                >
                                    <SegmentSelect
                                        brandId={brandId}
                                        disabled={!brandId}
                                        shouldFetch={!!brandId}
                                        value={segmentId}
                                        onChange={(val) => {
                                            setSegmentId(val);
                                            setSelectedManufacturers([]);
                                            setSelectedManufacturer(null);
                                            setSelectedVehicle(null);
                                            setVehicles([]);
                                            setModels([]);
                                            setVehicleModelMappings([]);
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24} xs={24} sm={12} lg={12} xxl={8}>
                                <Form.Item
                                    label="Pack Size"
                                    name="pack_size"
                                    rules={[
                                        {
                                            pattern: new RegExp(/^[\.0-9]*$/),
                                            message: "Only Numeric Characters Allowed",
                                        },
                                    ]}
                                >
                                    <Input
                                        maxLength={80}
                                        autoComplete="off"
                                        placeholder="Enter Pack Size"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Tabs defaultActiveKey="1">
                            {languages.map((lang, key) => {
                                const statusCheck = validationStatus[lang.short] ?? false;
                                return (

                                    <TabPane tab={<span>{lang.long} {validationStatus[lang.short] === false && <Badge dot color="red" />}</span>} key={lang.short}>

                                        <Row gutter={[24, 0]}>
                                            <Col span={24} xs={24} sm={12} lg={12}>

                                                <Form.Item label={`Name (${lang.long})`} name={`${lang.short}_name`}
                                                    rules={[
                                                        ...(lang.short === 'en' ? [
                                                            { required: true, message: `Please enter the name in ${lang.long}!` }
                                                        ] : []),
                                                        { max: 100, message: "Name should not contain more than 100 characters!" },
                                                        { min: 2, message: "Name should contain at least 2 characters!" },
                                                    ]}
                                                    initialValue={form.getFieldValue(`${lang.short}_name`)}
                                                    onChange={(data) => handleFieldChange(data, lang.short, 'title')}
                                                >

                                                    <Input
                                                        maxLength={80}
                                                        autoComplete="off"
                                                        placeholder={"Enter " + lang.name + " Name"}
                                                        onChange={() => handleFieldChange("", lang?.short, "name")}
                                                    />

                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={[24, 0]}>
                                            <Col span={24} xs={24} sm={24} lg={24}>
                                                <Form.Item label={`Description (${lang.long})`} name={`${lang.short}_description`}
                                                    rules={[
                                                        ...(lang.short === 'en' ? [
                                                            { required: true, message: `Please enter the name in ${lang.long}!` }
                                                        ] : []),
                                                        { min: 10, message: "Description should contain at least 10 characters!" },
                                                    ]}
                                                    initialValue={form.getFieldValue(`${lang.short}_description`)}
                                                    onChange={(data) => handleFieldChange(data, lang.short, 'description')}
                                                >

                                                    <DescriptionEditor
                                                        onChange={() => handleFieldChange("", lang?.short, "description")}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                    </TabPane>
                                );
                            })}
                        </Tabs>

                        <Row gutter={[24, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label="Specification"
                                    name="specification"
                                >
                                    <TextArea
                                        placeholder="Enter Specification"
                                        rows={4}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={[24, 0]} className="mb-3">
                            <Col span={24} xs={24} sm={24} lg={12} xxl={6}>
                                <Form.Item
                                    label="Product Image"
                                    name="image"
                                >
                                    <FileUpload handleFile={handleFile} fileList={image} />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item className="btn-row float-right mt-3">
                            <Button type="primary" loading={loading} htmlType="submit">
                                <CheckLineIcon size={15} /> Save Changes
                            </Button>
                        </Form.Item>

                    </Form>

                ) : (

                    <Form className="edit-page-wrap" form={form} onFinish={onCreate} autoComplete="off" layout="verticle" name="blog_form">

                        <Row gutter={[24, 0]}>

                            <Col span={24} xs={24} sm={12} lg={12} xxl={8}>
                                <Form.Item
                                    label="Part Number"
                                    name="part_number"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter the part number!",
                                        },
                                    ]}
                                >
                                    <Input
                                        autoComplete="off"
                                        placeholder="Enter Part Number"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24} xs={24} sm={12} lg={12} xxl={8}>
                                <Form.Item
                                    label="Price (INR)"
                                    name="price"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter the price!",
                                        },
                                        {
                                            pattern: new RegExp(/^[\.0-9]*$/),
                                            message: "Only Numeric Characters Allowed",
                                        },
                                    ]}
                                >
                                    <Input
                                        maxLength={80}
                                        autoComplete="off"
                                        placeholder="Enter Price"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24} xs={24} sm={12} lg={12} xxl={8}>
                                <Form.Item
                                    label="Ref. No"
                                    name="ref_no"
                                    rules={[
                                        {
                                            min: 2,
                                            message: "Please enter atleast 2 characters!",
                                        },
                                    ]}
                                >
                                    <Input
                                        autoComplete="off"
                                        placeholder="Enter Reference No."
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={12} xs={12} sm={12} md={8}>
                                <Form.Item
                                    name="brand_id"
                                    label="Select Brand"
                                    className="brand-elt"
                                    rules={[{ required: true, message: 'Please select a brand' }]}
                                >
                                    <BrandSelect
                                        value={brandId}
                                        onChange={(val) => {
                                            setBrandId(val);
                                            setCategoryId(null);
                                            setSegmentId(null);
                                            form.setFieldValue("brand_id", val);
                                            form.setFieldValue("category_id", undefined);
                                            form.setFieldValue("segment_id", undefined);
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={12} xs={12} sm={12} md={8}>
                                <Form.Item className="segment-elt"
                                    name="segment_id"
                                    label="Select Segment"
                                    rules={[{ required: true, message: 'Missing Segment Selection' }]}
                                >
                                    <SegmentSelect
                                        brandId={brandId}
                                        disabled={!brandId}
                                        shouldFetch={!!brandId}
                                        value={segmentId}
                                        onChange={(val) => {
                                            setSegmentId(val);
                                            form.setFieldValue("segment_id", val);
                                            setSelectedManufacturers([]);
                                            setSelectedManufacturer(null);
                                            setSelectedVehicle(null);
                                            setVehicles([]);
                                            setModels([]);
                                            setVehicleModelMappings([]);
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={12} xs={12} sm={12} md={8}>
                                <Form.Item className="category-elt"
                                    name="category_id"
                                    label="Select Category"
                                    rules={[{ required: true, message: 'Missing Category Selection' }]}
                                >
                                    <CategorySelect
                                        brandId={brandId}
                                        disabled={!brandId}
                                        shouldFetch={!!brandId}
                                        value={categoryId}
                                        onChange={(val) => {
                                            setCategoryId(val);
                                            form.setFieldValue("category_id", val);
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24} xs={24} sm={24} md={24}>
                                <Form.Item
                                    name="all_vehicle"
                                    valuePropName="checked"
                                    initialValue={true}
                                >
                                    <Checkbox
                                        onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            setAllVehicle(isChecked);
                                            form.setFieldValue("all_vehicle", isChecked);
                                            if (isChecked) {
                                                form.setFieldValue("vehicle_manufacturer_ids", undefined);
                                            }
                                        }}
                                    >
                                        <span className="font-medium">Available for All Vehicles</span>
                                    </Checkbox>
                                </Form.Item>
                            </Col>

                            {!allVehicle && (
                                <Col span={24} xs={24} sm={24} md={24}>
                                    <Form.Item
                                        name="vehicle_manufacturer_ids"
                                        label="Select Vehicle Manufacturers"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please select at least one vehicle manufacturer!'
                                            }
                                        ]}
                                    >
                                        <VehicleManufacturerSelect
                                            segmentId={segmentId}
                                            value={form.getFieldValue("vehicle_manufacturer_ids")}
                                            onChange={(val) => form.setFieldValue("vehicle_manufacturer_ids", val)}
                                            multiple={true}
                                        />
                                    </Form.Item>
                                </Col>
                            )}

                            <Col span={24} xs={24} sm={24} md={24}>

                                <Tabs defaultActiveKey={languages[0].short}>

                                    {languages.map(lang => (

                                        <TabPane tab={<span>{lang.long} {validationStatus[lang.short] === false && <Badge dot color="red" />}</span>} key={lang.short}>

                                            <Form.Item label={`Name (${lang.long})`} name={`${lang.short}_name`}
                                                rules={[
                                                    ...(lang.short === 'en' ? [
                                                        { required: true, message: `Please enter the name in ${lang.long}!` }
                                                    ] : []),
                                                    { max: 100, message: "Name should not contain more than 100 characters!" },
                                                    { min: 2, message: "Name should contain at least 2 characters!" },
                                                ]}
                                                initialValue={form.getFieldValue(`${lang.short}_name`)}
                                                onChange={(data) => handleFieldChange(data, lang.short, 'title')}
                                            >

                                                <Input autoComplete="off" placeholder={`Enter name in ${lang.long}`} />
                                            </Form.Item>

                                            <Form.Item label={`Description (${lang.long})`} name={`${lang.short}_description`}
                                                rules={[
                                                    { required: lang.short === 'en', message: `Please enter the description in ${lang.long}!` },
                                                ]}
                                                initialValue={form.getFieldValue(`${lang.short}_description`)}
                                            >
                                                <DescriptionEditor value={form.getFieldValue(`${lang.short}_description`)} placeholder={`Enter Description in ${lang.long}`} onChange={(data) => handleFieldChange(data, lang.short, 'description')} />

                                            </Form.Item>
                                        </TabPane>
                                    ))}
                                </Tabs>
                            </Col>

                            <Col span={24} xs={24} sm={12} lg={12} xxl={12}>
                                <Form.Item
                                    label="Specification (Max: 300)"
                                    name="specification"
                                    rules={[
                                        {
                                            min: 2,
                                            message: "Please enter atleast 2 characters!",
                                        },
                                    ]}
                                >
                                    <TextArea
                                        rows={4}
                                        maxLength={300}
                                        minLength={2}
                                        autoComplete="off"
                                        placeholder="Enter Specification"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24} xs={24} sm={24} md={10}>
                                <Form.Item
                                    label={
                                        <div>
                                            <span>Image</span>
                                            <span className="ml-1 text-gray-500">
                                                (Accept : png, jpg, jpeg, avif, webp, svg, gif)
                                            </span>
                                        </div>
                                    }
                                    valuePropName="value" name="image"
                                /* rules={[
                                    {
                                        required: true,
                                        message: 'Please upload a image!',
                                    },
                                ]} */
                                >
                                    <FileUpload value={image} filterType={["image"]} btnName={'Image'} onChange={(data) => handleFile(data)} />

                                </Form.Item>
                            </Col>

                        </Row>

                        <Form.Item className="btn-row float-right mt-3">
                            <Button type="primary" loading={loading} htmlType="submit">
                                <CheckLineIcon size={15} /> {isEdit ? "Update" : "Submit"}
                            </Button>
                        </Form.Item>
                    </Form>
                )}
            </Spin>
        </Card>
    )
}

export default AddEdit;